/* The Individual Set builder's script (sections/set-product.liquid), moved out of the section verbatim on 2026-10-25. */
  

function handleAcrylicClick() {
  const currentCover = getSelectedDisplayCover();
  const newCover = (currentCover === 'acrylic') ? 'none' : 'acrylic';
  setDisplayCover(newCover);
}

function handleGlassClick() {
  const currentCover = getSelectedDisplayCover();
  setDisplayCover(currentCover === 'glass' ? 'none' : 'glass');
}

function initAddonBindings() {
  cfSafeOn('display-cover-acrylic', 'click', handleAcrylicClick);
  cfSafeOn('display-cover-glass',   'click', handleGlassClick);

  cfSafeOn('option-button-plaque-steel', 'click', () => {
    if (window.CF.STATE.choices.plaque && window.CF.STATE.plaqueMaterial === 'steel') {
      setPlaque('none');
      return;
    }
    window.CF.STATE.plaqueMaterial = 'steel';
    setPlaque('steel');
  });

  cfSafeOn('option-button-plaque-brass', 'click', () => {
    if (window.CF.STATE.choices.plaque && window.CF.STATE.plaqueMaterial === 'brass') {
      setPlaque('none');
      return;
    }
    window.CF.STATE.plaqueMaterial = 'brass';
    setPlaque('brass');
  });

  allATC().forEach(btn => {
    btn.addEventListener('click', handleAddToCart);
  });

  const autoHeadEl = document.getElementById('auto-headline');
  const autoSubEl  = document.getElementById('auto-subheadline');

  if (autoHeadEl) {
    autoHeadEl.addEventListener('change', () => {
      if (window.CFPlaque?.applyAutoFill) {
        window.CFPlaque.applyAutoFill();
        window.CFPlaque.syncToGallery();
      }
    });
  }

  if (autoSubEl) {
    autoSubEl.addEventListener('change', () => {
      if (window.CFPlaque?.applyAutoFill) {
        window.CFPlaque.applyAutoFill();
        window.CFPlaque.syncToGallery();
      }
    });
  }
}


function cfLockScroll() {
  if (window.CF.STATE.scroll.locked) {
    return;
  }
  window.CF.STATE.scroll.savedY = window.scrollY || window.pageYOffset || 0;
  
  document.documentElement.classList.add('cf-modal-locked');
  document.body.classList.add('cf-modal-locked');
  
  document.body.style.position = 'fixed';
  document.body.style.top = `-${window.CF.STATE.scroll.savedY}px`;
  document.body.style.width = '100%';
  
  window.CF.STATE.scroll.locked = true;
}

function cfUnlockScroll() {
  if (!window.CF.STATE.scroll.locked) {
    return;
  }
  
  const restoreY = window.CF.STATE.scroll.savedY;
  
  document.documentElement.classList.remove('cf-modal-locked');
  document.body.classList.remove('cf-modal-locked');
  
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  
  window.CF.STATE.scroll.locked = false;
  
  window.scrollTo({
    top: restoreY,
    left: 0,
    behavior: 'auto'
  });
}

function cfSyncScrollLock() {
  const anyModalOpen = !!document.querySelector('x-modal[open]');
  
  if (anyModalOpen && !window.CF.STATE.scroll.locked) {
    cfLockScroll();
  } else if (!anyModalOpen && window.CF.STATE.scroll.locked) {
    cfUnlockScroll();
  }
}

function cfInitScrollLock() {
  const modalObserver = new MutationObserver(() => {
    requestAnimationFrame(cfSyncScrollLock);
  });
  
  document.querySelectorAll('x-modal').forEach(modal => {
    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['open', 'class', 'style']
    });
  });
  
  cfSyncScrollLock();
}




function cfSafeOn(id, event, handler, options) {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener(event, handler, options || false);
  return el;
}

function cfInitAddonVariants() {
  const data = window.CF.PRODUCT_DATA;

  const acrylicIdEl = document.getElementById('addon-acrylic-id');
  if (acrylicIdEl) {
    acrylicIdEl.value = data.cover.acrylicId;
    acrylicIdEl.setAttribute('data-price-cents', data.cover.acrylicPriceCents);
  }

  const glassIdEl = document.getElementById('addon-glass-id');
  if (glassIdEl) {
    glassIdEl.value = data.cover.glassId;
    glassIdEl.setAttribute('data-price-cents', data.cover.glassPriceCents);
  }

  const priceAcrylic = document.getElementById('price-acrylic-total');
  if (priceAcrylic) priceAcrylic.innerHTML = formatAddonPrice(data.cover.acrylicPriceCents);

  const priceGlass = document.getElementById('price-glass-total');
  if (priceGlass) priceGlass.innerHTML = formatAddonPrice(data.cover.glassPriceCents);
}

function init () {
  cfInitAddonVariants();
  /*
    Before updateUI(), so the price, the gallery and the ATC state are painted
    from the (empty) selection rather than from nothing.
  */
  CFSetPicker.init();

  initAddonBindings();

  window.CFPlaque.init();
  if (window.CFPlaque?.applyAutoFill) {
    window.CFPlaque.applyAutoFill();
    window.CFPlaque.syncToGallery();
  }
  /*
    The saved cover, engraving and words, over what the auto-fill just wrote (CFSetPicker, "THE SET IS KEPT").
  */
  CFSetPicker.restoreExtras();

  updateUI();
  initLiquidGallery();
  cfInitScrollLock();
  cfPreloadOverlays();
}
  /*  1. COMMON HELPERS */
/*
  Picking a cover or a plaque brings the cards up into view so it can be seen landing on them — up the page only. The
  row of cards stays where the visitor left it (2026-10-04, on request): it used to slide back to the first card as
  well, which in a Set of four or more took away the card they were looking at.
*/
function scrollGalleryIntoView() {
  const gallery = document.querySelector('.cube-gallery-wrapper');
  if (!gallery) return;
  /*  A phone: the gallery to the top of the screen, rather than the add-ons the tap came from. */
  if (window.CF.isMobile()) {
    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  /*
    Where the title stands over the gallery (from 1100px, theme.css "THE GALLERY ACROSS THE PAGE"), the cards come to
    the top of the window, under the header, with "Build your own Set" just out of view above them: the title is not
    part of what is being added to. Beside or under the gallery the title is no place to stop, and the cards are
    centred in the window instead. Both scroll the page alone — the row is not an ancestor of what is scrolled to.
  */
  const head = document.querySelector('.cf-set-head');
  if (head && head.getBoundingClientRect().bottom <= gallery.getBoundingClientRect().top) {
    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  const box = (gallery.querySelector('.cc_city-preview-wrapper') || gallery).getBoundingClientRect();
  window.scrollTo({ top: window.scrollY + box.top + box.height / 2 - window.innerHeight / 2, behavior: 'smooth' });
}






function allATC () {
  return document.querySelectorAll('.add-all-to-cart');
}
  /*
  Add-on prices are one figure: what one per city costs, for as many cities as the Set holds.

  Earlier versions said the quantity here too — first as the unit in brackets over the
  total, then as "3x EUR40.00". Both restated something the heading above already says
  ("Add 3x Display Cover"), and neither is the number a customer is comparing. What
  decides between acrylic and glass is what each choice adds to the order.
  */
function formatAddonPrice(unitCents) {
  /*  An add-on adds to the total, and says so: "+€120.00" — see price-list, role addon. */
  return '+' + formatCents(unitCents * addonQty());
}

function updateDisplayCoverTotal() {
  const acrylicTotalEl = document.getElementById('price-acrylic-total');
  const glassTotalEl = document.getElementById('price-glass-total');
  
  if (acrylicTotalEl) {
    acrylicTotalEl.innerHTML = formatAddonPrice(window.CF.PRODUCT_DATA.cover.acrylicPriceCents);
  }
  if (glassTotalEl) {
    glassTotalEl.innerHTML = formatAddonPrice(window.CF.PRODUCT_DATA.cover.glassPriceCents);
  }
}


function updatePlaqueTotal() {
  const materials = window.CF.CONSTANTS.PLAQUE_MATERIALS || {};

  ['steel', 'brass'].forEach(mat => {
    const def = materials[mat];
    if (!def) return;

    const unitCents = Number(def.priceCents) || 0;
    const totalEl = document.getElementById(`price-plaque-${mat}-total`);
    
    if (totalEl) {
      totalEl.innerHTML = formatAddonPrice(unitCents);
    }
  });
}



function getSelectedDisplayCover() {
  return window.CF.STATE.choices.cover;
}

function cfMoneyStringFromCents(cents) {
  return (Number(cents || 0) / 100).toFixed(2);
}
/*
  A cover or plaque pick, as CustomizeProduct for our own tracking (assets/cf-tracking.js). It used
  to go to Elevar's data layer too; Elevar was removed in October 2026.
*/
function trackCustomizePick(product, value) {
  if (!window.cfTrack) return;
  const variantId = String(product.variant_id || product.id);
  window.cfTrack('CustomizeProduct', {
    currency: window.CF.LOCALE.currency,
    value: Number(value),
    content_ids: [variantId],
    contents: [{ id: variantId, quantity: 1, item_price: Number(value) }],
    content_name: product.name,
    content_category: product.category
  });
}

function pushDisplayCoverDL(coverType) {
  if (coverType === "none") return;

  const isAcrylic = coverType === "acrylic";

  const variantId = isAcrylic
    ? window.CF.PRODUCT_DATA.cover.acrylicId
    : window.CF.PRODUCT_DATA.cover.glassId;

  const priceCents = isAcrylic
    ? window.CF.PRODUCT_DATA.cover.acrylicPriceCents
    : window.CF.PRODUCT_DATA.cover.glassPriceCents;

  const value = cfMoneyStringFromCents(priceCents);

  trackCustomizePick({
    id: String(variantId),
    name: "Display Cover",
    brand: "CITYFRAMES",
    category: "Display Cover",
    variant: isAcrylic ? "Acrylic" : "Glass",
    price: value,
    quantity: 1,
    list: window.location.pathname,
    product_id: window.CF.SET_T["cover_product_id"],
    variant_id: String(variantId),
    compare_at_price: "0.00",
    image: ""
  }, value);
}

function pushPlaqueDL(material) {
  if (material === "none") return;

  const def = window.CF.CONSTANTS.PLAQUE_MATERIALS?.[material];
  if (!def) return;

  const value = cfMoneyStringFromCents(def.priceCents);

  trackCustomizePick({
    id: String(def.id),
    name: "Engraved Plaque",
    brand: "CITYFRAMES",
    category: "Engraved Plaque",
    variant: material === "brass" ? "Brass" : "Stainless Steel",
    price: value,
    quantity: 1,
    list: window.location.pathname,
    product_id: window.CF.SET_T["plaque_product_id"],
    variant_id: String(def.id),
    compare_at_price: "0.00",
    image: material === "brass"
      ? window.CF.SET_T["plaque_brass_preview"]
      : window.CF.SET_T["plaque_steel_preview"]
  }, value);
}
  /*
    2. CORE UPDATE FLOW
    One function to rule them all: every time something changes,
    we gather the data and update the UI accordingly
  */

function updateUI() {
  const coverSelected = getSelectedDisplayCover();
  const isMobile = window.CF.isMobile();

  updateTotalSummary();
  updateLiquidGallery(coverSelected, !document.getElementById('addon-plaque-id')?.disabled, isMobile);

  updateDisplayCoverQuantities(1, coverSelected);
  updateDisplayCoverTotal();
  updatePlaqueTotal();
  
  if (window.CFPlaque) {
    window.CFPlaque.updateVisibility(1);
    window.CFPlaque.updatePreview(1);
    window.CFPlaque.syncToGallery();
  }
  updateAddToCartState();
  clearError();
}
/*  MERGED GALLERY & MODAL LOGIC */

function cfSetCards() {
  const container = document.getElementById('configurator-carousel');
  return Array.from(container?.querySelectorAll('.cf-trio-cell .cube_gallery_image_card') || []);
}

function updateLiquidGallery(cover, plaqueEnabled, isMobile, forceRebuild = false) {
  /*
    A COVER AND A PLAQUE ON EVERY CARD: each city's card takes the single-CUBE
    artwork at the single-CUBE position, which is what the CUBE page does.
  */
  cfSetCards().forEach((card, idx) => {
    refreshCoverOverlay(card, cover, forceRebuild);
    refreshPlaqueOverlays(card, plaqueEnabled, isMobile, forceRebuild, idx + 1);
  });
}
/*
  The cards start empty and the picker loads each city's pictures itself (CFSetPicker's paintCells), so all there is
  to set up here is the overlays.
*/
function initLiquidGallery() {
  updateLiquidGallery(getSelectedDisplayCover(), !document.getElementById('addon-plaque-id')?.disabled, window.CF.isMobile(), true);
}

window.__CF_OVERLAY_STATE = window.__CF_OVERLAY_STATE || Object.create(null);

window.cfGetOverlayState = function(url){
  return window.__CF_OVERLAY_STATE[url] || { loaded: false };
};

window.cfMarkOverlayLoaded = function(url){
  window.__CF_OVERLAY_STATE[url] = { loaded: true };
};


function refreshCoverOverlay(container, cover, forceRebuild = false) {
  const target = container.classList.contains('cube_gallery_image_card')
                 ? container
                 : container.querySelector('.cf-trio-cell .cube_gallery_image_card');

  if (!target) return;

  const existing = target.querySelector('.cf-cover-overlay');
  if (cover === 'none') {
    if (existing) existing.remove();
    return;
  }

  const url = window.CF.PRODUCT_DATA?.overlay?.[cover];
  if (!url) return;

  if (existing && existing.src === url && !forceRebuild) return;
  if (existing) existing.remove();

  const ov = document.createElement('img');
  ov.className = 'cf-cover-overlay';
  ov.src = url;
  /*  The magnifier's close-up swaps to this; the card itself never loads it. */
  const fullUrl = window.CF.PRODUCT_DATA?.overlayFull?.[cover];
  if (fullUrl) ov.dataset.imgFull = fullUrl;
  Object.assign(ov.style, {
    position: 'absolute',
    inset: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    pointerEvents: 'none',
    zIndex: '10' 
  });

  target.appendChild(ov);
}

function refreshPlaqueOverlays(container, enabled, isMobile, forceRebuild = false, cityIndex = 1) {
  const target = container.classList.contains('cube_gallery_image_card')
                 ? container
                 : container.querySelector('.cf-trio-cell .cube_gallery_image_card');

  if (!target) return;

  const existing = target.querySelectorAll('.plaque-overlay');
  if (!enabled) {
    existing.forEach(el => el.remove());
    return;
  }
  /*
    ONE PLAQUE PER CARD, at the centred single-CUBE position the CUBE product
    page uses (PLAQUE_GALLERY).
  */
  const cfg = window.CF.CONSTANTS.PLAQUE_GALLERY[isMobile ? 'mobile' : 'desktop'];
  const mat = window.CF.STATE.plaqueMaterial || 'steel';

  if (existing.length !== 1 || forceRebuild) {
    existing.forEach(el => el.remove());
    const pl = document.createElement('div');
    pl.className = 'plaque-overlay';
    pl.dataset.cityIndex = String(cityIndex);
    pl.innerHTML = `
      <span class="plaque-overlay-inner" data-city-index="${cityIndex}">
        <span class="plaque-text-head"></span>
        <span class="plaque-text-sub"></span>
      </span>`;
    target.appendChild(pl);
  }

  target.querySelectorAll('.plaque-overlay').forEach(pl => {
    pl.dataset.cityIndex = String(cityIndex);
    const inner = pl.querySelector('.plaque-overlay-inner');
    if (inner) inner.dataset.cityIndex = String(cityIndex);
    Object.assign(pl.style, {
      position: 'absolute',
      zIndex: '11',
      top: cfg.top,
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'auto',
      height: cfg.height,
      pointerEvents: 'none'
    });
    pl.classList.toggle('plaque-overlay--steel', mat === 'steel');
    pl.classList.toggle('plaque-overlay--brass', mat === 'brass');
  });

  if (window.CFPlaque) window.CFPlaque.syncToGallery();
}

function formatCents(cents) {
  /*
    As checkout writes it, in the page's language and market (window.cfMoney, js-variables), whatever the browser speaks.
    See cfMoney in js-variables.
  */
  return window.cfMoney(cents, window.CF.LOCALE.moneyFormat);
}

function formatPrice(cents) {
  /*
    The price this page sells - its total, compare-at and saving - without ".00" when it has no cents, as
    price-list prints it. See cfPrice in js-variables.
  */
  return window.cfPrice(cents, window.CF.LOCALE.moneyFormat);
}

function updateTotalSummary() {
  const priceEls = document.querySelectorAll('.js-total-price');
  const savingEls = document.querySelectorAll('.js-total-saving');
  /*
    THE SAME CITIES BOUGHT ONE BY ONE, at the prices they sell for today: what the Set is compared with in
    "You save €40.00 as a Set" — see set-singles, which works out the same figure for the first paint.
    AN EMPTY SLOT COUNTS AS A LIST-PRICE CUBE, as it does below for the price.
  */
  const base = Number(window.CF.PRODUCT_DATA.cubePriceCents) || 0;
  const slots = window.CF.SET_CITIES || [];
  let singles = 0;
  for (let i = 0; i < setCount(); i++) {
    const c = slots[i];
    singles += c ? (Number(c.price) || 0) : base;
  }
  /*
    THE PRICE THE CART WILL CHARGE, arrived at the same way the cart transform
    arrives at it: the cities' own lines, less the Set's amount for its size
    (setDiscountCents). Reading the size variant's price instead would be wrong
    the moment a clearance city is in the Set — its line is cheaper, so the
    merged line is cheaper, and the page would have quoted more than the cart
    takes.

    An empty slot at list price is what makes the page open on the size
    variant's own price. Every city chosen is either that price or a clearance
    one, so the number can only fall from there: the quote is never lower than
    what the cart will take.
  */
  let totalFinal = Math.max(singles - setDiscountCents(setCount()), 0);
  /*
    The saving is the Set's alone: a clearance city is already at its own price on both sides, so its reduction
    is not counted as the Set's, and the add-ons below cost the same either way.
  */
  const saving = Math.max(singles - totalFinal, 0);

  const cover = getSelectedDisplayCover();
  const plaqueActive = !document.getElementById('addon-plaque-id')?.disabled;

  let coverUnit = 0;
  if (cover === 'acrylic') coverUnit = Number(window.CF.PRODUCT_DATA.cover.acrylicPriceCents) || 0;
  if (cover === 'glass') coverUnit = Number(window.CF.PRODUCT_DATA.cover.glassPriceCents) || 0;
  let plaqueUnit = 0;
  const plaqueMat = plaqueActive ? (window.CF.STATE?.plaqueMaterial || 'steel') : null;
  if (plaqueActive) {
    /*  Reads the selected material; PLAQUE_UNIT_CENTS is always steel's price. */
    const mat = window.CF.CONSTANTS.PLAQUE_MATERIALS?.[plaqueMat];
    plaqueUnit = Number(mat?.priceCents) || Number(window.CF.CONSTANTS.PLAQUE_UNIT_CENTS) || 0;
  }
  const addOns = (coverUnit + plaqueUnit) * addonQty();
  totalFinal += addOns;

  priceEls.forEach(el => { el.innerText = formatPrice(totalFinal); });
  window.cfKlarnaAmount?.(totalFinal); /* Klarna's line quotes the Set as built, add-ons included (klarna-message) */
  /*
    The amount is written into its own span and the saving line around it is shown or hidden — see price-list.
  */
  savingEls.forEach(el => {
    const line = el.closest('.price-list__saving') || el;
    el.innerText = formatPrice(saving);
    line.hidden = saving <= 0;
  });
  /*
    The singles total struck through above the price, shown only while there is a saving — the same
    element the non-set configurators drive, so the "Regular price" label survives for screen readers.
    See price-list: what is struck is the cities one by one, never a compare_at on the set's variant —
    and the covers and plaques with them, as the price beside it has them: struck without them, a Set
    with add-ons read as dearer than its own "was" price (€480 against €340).
  */
  document.querySelectorAll('.js-total-compare').forEach(el => {
    const box = el.closest('compare-at-price') || el;
    if (saving > 0) {
      el.innerText = formatPrice(singles + addOns);
      box.hidden = false;
    } else {
      box.hidden = true;
    }
  });

  paintOverview(base, coverUnit ? cover : null, coverUnit, plaqueMat, plaqueUnit);
  updateSetHeights();
}
/*
  THE OVERVIEW'S LINES (2026-10-02), from the numbers the price above was just worked out from, so they add up to
  it: a line per slot, and under the rule a line for the covers and one for the plaques while they are chosen.
  The first city is at its own price and each one after it at its price less its share of what the Set takes off
  (setDiscountCents, shared evenly in whole units, a unit that will not share going to the last cities) — at list
  price a Set of four reads €85, €65, €65, €65, which is the €280 the Set costs. A city the Set takes something off shows the price it
  sells for on its own struck through before it, as price-list strikes the cities under the price — "€85.00 €65.00",
  the struck figures adding up to the struck total. Before the amount rather than after it, as price-list has it,
  so the amounts stay one column on the right. An empty slot is the list-price CUBE the price counts it as, under
  the field's own "Choose a city". The add-ons are the accordions' titles with the option and the number of
  cities: "Display Covers · Acrylic × 4". Written as text, never as HTML: a city's title is the shop's data.
*/
function paintOverview(base, cover, coverUnit, plaqueMat, plaqueUnit) {
  const cityList = document.querySelector('[data-set-overview-cities]');
  const addonList = document.querySelector('[data-set-overview-addons]');
  const rule = document.querySelector('[data-set-overview-rule]');
  if (!cityList || !addonList) return;

  const t = window.CF.T.overview;
  const n = setCount();
  const slots = window.CF.SET_CITIES || [];
  /*
    Shared in whole units of the currency, the price's own step: in cents, $85 off three cities came to $96.67,
    $96.67 and $96.66, and ¥11,000 to three ¥12,333.33 that a no-decimals format prints as ¥12,333 — lines a yen
    short of the ¥53,000 under them. The units that will not share go one each to the last cities.
  */
  const off = setDiscountCents(n);
  const unit = off % 100 === 0 ? 100 : 1;
  const extra = Math.max(n - 1, 1);
  const shareUnits = Math.floor(off / unit / extra);
  const restUnits = Math.round(off / unit) - shareUnits * extra;
  const offFor = (i) => i < 1 ? 0 : (shareUnits + (i > n - 1 - restUnits ? 1 : 0)) * unit;
  /*  The screen reader's "Regular price" and "Sale price", as price-list says them. */
  function srOnly(text) {
    const el = document.createElement('span');
    el.className = 'sr-only';
    el.textContent = text;
    return el;
  }

  function line(label, cents, empty, was) {
    const li = document.createElement('li');
    li.className = 'cf-set-overview__line' + (empty ? ' is-empty' : '');
    const name = document.createElement('span');
    name.textContent = label;
    const price = document.createElement('span');
    price.className = 'cf-set-overview__amount';
    if (was > cents) {
      const struck = document.createElement('compare-at-price');
      struck.className = 'text-subdued line-through';
      struck.append(srOnly(t.regular_price), formatCents(was));
      const now = document.createElement('span');
      now.append(srOnly(t.sale_price), formatCents(cents));
      price.append(struck, now);
    } else {
      price.textContent = formatCents(cents);
    }
    li.append(name, price);
    return li;
  }

  const cities = [];
  for (let i = 0; i < n; i++) {
    const c = slots[i];
    const single = c ? (Number(c.price) || 0) : base;
    const cents = single - offFor(i);
    cities.push(line(c ? c.title : t.empty, cents, !c, single));
  }
  cityList.replaceChildren(...cities);

  const qty = addonQty();
  const addons = [];
  if (cover) addons.push(line(`${t.cover} · ${t[cover]} × ${qty}`, coverUnit * qty));
  if (plaqueMat) addons.push(line(`${t.plaque} · ${t[plaqueMat]} × ${qty}`, plaqueUnit * qty));
  addonList.replaceChildren(...addons);
  addonList.hidden = !addons.length;
  if (rule) rule.hidden = !addons.length;
}
/*
  THE DIMENSIONS LIST, WRITTEN FROM THE SLOTS as the reader chooses: a span per city, the city's title then its
  height, in the markup the Trio page's Liquid writes for a pre-set trio. The arithmetic is `dimension`'s, handed
  over in window.CF.DIM: inches are the centimetres divided by 2.54, both to one decimal, and the decimal point is
  the language's. A city with no height on it is left out, and when none of the chosen cities has one the "varies
  from city to city" line stays.
*/
function updateSetHeights() {
  const box = document.querySelector('.js-trio-heights');
  if (!box) return;
  const cfg = window.CF.DIM || {};
  const rows = Array.from({ length: setCount() }, (_, i) => i + 1)
    .map(i => document.getElementById(`City${i}`))
    .map(sel => (sel && sel.value) ? cfGetVariantById(sel.value) : null)
    .filter(v => v && v.heightCm !== null && v.heightCm !== undefined)
    .map(v => {
      const cm = Number(v.heightCm);
      const shown = (cfg.imperial ? cm / 2.54 : cm).toFixed(1);
      const point = cfg.point && cfg.point !== '.' ? shown.replace('.', cfg.point) : shown;
      const name = document.createElement('span');
      name.className = 'js-trio-height';
      name.textContent = `${v.title}: ${point} ${cfg.unit}`;
      return name.outerHTML;
    });
  box.innerHTML = rows.length ? rows.join('') : (cfg.note || '');
}
  /*  4. EVENT HANDLERS */


  function setDisplayCover(cover) {
    window.CF.STATE.choices.cover = cover;
    const acrylicId  = document.getElementById('addon-acrylic-id');
    const glassId    = document.getElementById('addon-glass-id');
    if (acrylicId) acrylicId.disabled = true;
    const acrylicWrapper = document.getElementById('option-button-acrylic');
    if (acrylicWrapper) acrylicWrapper.classList.remove('active');

    if (glassId) glassId.disabled = true;
    const glassWrapper = document.getElementById('option-button-glass');
    if (glassWrapper) glassWrapper.classList.remove('active');

    if (cover === 'acrylic') {
      if (acrylicWrapper) acrylicWrapper.classList.add('active');
      if (acrylicId)      acrylicId.disabled = false;
    } else if (cover === 'glass') {
      if (glassWrapper) glassWrapper.classList.add('active');
      if (glassId)      glassId.disabled = false;
    }
    /*
      Jump the gallery to the main-variant slide so the user can see
      the cover overlay land on the model. Skipped on deselect — only
      fires when an addon is actually being picked.
      Quiet while the saved Set is put back (CFSetPicker.restoreExtras): no jump, no analytics event, and nothing
      to save that was not just read.
    */
    const quiet = window.CF.STATE.quiet === true;
    if (!quiet && (cover === 'acrylic' || cover === 'glass')) {
      scrollGalleryIntoView();
    }

    if (!quiet) pushDisplayCoverDL(cover);
    updateUI();
    if (!quiet) CFSetPicker.save();
  }

// reveal: false keeps the gallery where it is (the plaque designer turns the plaque on from its own window).
function setPlaque(type, reveal = true) {
  const isEnabled = (type !== 'none');
  window.CF.STATE.choices.plaque = isEnabled;

  const addonPlaqueId   = document.getElementById('addon-plaque-id');
  const addonPlaqueQty  = document.getElementById('addon-plaque-qty');
  /*
    Animated collapse around the "Customize Text" button — replaces
    the previous opacity-only toggle that kept the slot reserved as
    whitespace even when no plaque was selected.
  */
  const customizeCollapse = document.getElementById('cc-plaque-customize-collapse');
  const designBtn = document.getElementById('plaque-design-btn');

  if (isEnabled) {
    if (addonPlaqueId) addonPlaqueId.disabled = false;
    if (addonPlaqueQty) addonPlaqueQty.disabled = false;

    if (customizeCollapse) customizeCollapse.classList.add('is-open');
    if (designBtn) designBtn.disabled = false;

    applyPlaqueVariant();
    updatePlaqueMaterialUI();
    /*
      Jump the gallery to the main-variant slide so the plaque overlay
      is visible on the model. Skipped on deselect, and while the saved Set is put back.
    */
    if (reveal && window.CF.STATE.quiet !== true) scrollGalleryIntoView();
  } else {
    if (addonPlaqueId) addonPlaqueId.disabled = true;
    if (addonPlaqueQty) addonPlaqueQty.disabled = true;

    if (customizeCollapse) customizeCollapse.classList.remove('is-open');
    /*
      Block opening the Plaque Designer modal when no plaque is picked —
      the collapse hides the button visually but the inner <button> is
      still keyboard- and click-reachable through the 0fr grid row.
    */
    if (designBtn) designBtn.disabled = true;

    const steel = document.getElementById('option-button-plaque-steel');
    const brass = document.getElementById('option-button-plaque-brass');
    if (steel) steel.classList.remove('active');
    if (brass) brass.classList.remove('active');
  }

  const quiet = window.CF.STATE.quiet === true;
  if (!quiet) pushPlaqueDL(isEnabled ? window.CF.STATE.plaqueMaterial : "none");
  updateUI();
  if (window.CFPlaque) {
    window.CFPlaque.updateVisibility(1);
  }
  if (!quiet) CFSetPicker.save();
}


function updatePlaqueModalImage(material) {
  const steelImages = document.querySelectorAll('.plaque-image-steel');
  const brassImages = document.querySelectorAll('.plaque-image-brass');

  if (material === 'steel') {
    steelImages.forEach(img => {
      img.style.display = 'block';
    });
    brassImages.forEach(img => {
      img.style.display = 'none';
    });
  } else if (material === 'brass') {
    steelImages.forEach(img => {
      img.style.display = 'none';
    });
    brassImages.forEach(img => {
      img.style.display = 'block';
    });
  }
}


function updatePlaqueMaterialUI() {
  const steel = document.getElementById('option-button-plaque-steel');
  const brass = document.getElementById('option-button-plaque-brass');
  const mat = window.CF.STATE.plaqueMaterial || 'steel';
  const isEnabled = window.CF.STATE.choices.plaque;

  if (steel && brass) {
    steel.classList.toggle('active', isEnabled && mat === 'steel');
    brass.classList.toggle('active', isEnabled && mat === 'brass');
  }
  /*  Update the visual overlays in the gallery */
  document.querySelectorAll('.plaque-overlay').forEach(pl => {
    pl.classList.toggle('plaque-overlay--steel', mat === 'steel');
    pl.classList.toggle('plaque-overlay--brass', mat === 'brass');
  });

  updatePlaqueModalImage(mat);
}



function applyPlaqueVariant() {
  const addonPlaqueId = document.getElementById('addon-plaque-id');
  if (!addonPlaqueId) return;

  const mat = window.CF.STATE.plaqueMaterial || 'steel';
  const def = window.CF.CONSTANTS.PLAQUE_MATERIALS?.[mat];
  if (!def) return;

  addonPlaqueId.value = def.id;
  addonPlaqueId.setAttribute('data-price-cents', def.priceCents);
}


(function() {
  'use strict';

  const PlaqueModule = {
    initialized: false,
    getConfig() {
      return {
        maxSlots: window.CF?.CONSTANTS?.MAX_SLOTS || 1,
        gallery: window.CF?.CONSTANTS?.PLAQUE_GALLERY || {}
      };
    }
  };
  /*  UTILITY FUNCTIONS */

  function getVariantForSlot(i) {
    const sel = document.getElementById(`City${i}`);
    if (!sel || !sel.value) return null;
    return window.CF_VARIANT_LOOKUP?.byId?.[String(sel.value)] || null;
  }

  function stripFlagEmoji(str) {
    return str.replace(/[\u{1F1E6}-\u{1F1FF}]/gu, '').trim();
  }

  function isArabic(text) {
    return /[\u0600-\u06FF]/.test(text);
  }

  function getActiveCityCount() {
    const maxSlots = PlaqueModule.getConfig().maxSlots;
    let count = 0;
    for (let i = 1; i <= maxSlots; i++) {
      const sel = document.getElementById(`City${i}`);
      if (sel && sel.value && sel.value !== "") count++;
    }
    return Math.max(count, 1);
  }
  /*  PREVIEW RENDERING (Designer Modal & Small Preview Badges) */

  function updatePlaqueModalPreview(cityIndex) {
    const headlineInput = document.getElementById(`plaque-note-${cityIndex}`);
    const subInput = document.getElementById(`plaque-subnote-${cityIndex}`);
    const wrappers = document.querySelectorAll(
      `#plaque-preview-cityname-${cityIndex}`
    );

    if (!headlineInput || wrappers.length === 0) return;

    wrappers.forEach(wrapper => {
      let overlay = wrapper.querySelector('.plaque-modal-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'plaque-modal-overlay';
        wrapper.appendChild(overlay);
      }
      overlay.innerHTML = '';

      const widthPx = wrapper.clientWidth;
      const headlineSize = widthPx * 0.06;
      const subSize = widthPx * 0.03;

      const rawHeadline = headlineInput.value.trim();
      const previewHeadline = rawHeadline.toUpperCase().replace(/❤️|❤|♥/g, '♡');
      
      const h = document.createElement('span');
      h.textContent = previewHeadline;
      h.style.fontSize = `${headlineSize}px`;
      h.style.fontWeight = 'bold';
      h.style.textTransform = 'uppercase';
      h.style.color = '#3d3d3d';
      h.style.lineHeight = '1';

      if (isArabic(rawHeadline)) {
        h.style.direction = 'rtl';
        h.style.transform = 'translateY(-12%)';
      }
      overlay.appendChild(h);

      if (subInput && subInput.value.trim()) {
        const rawSub = subInput.value.trim();
        const previewSub = rawSub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
        
        const s = document.createElement('span');
        s.textContent = previewSub;
        s.style.fontSize = `${subSize}px`;
        s.style.lineHeight = '1';
        s.style.textTransform = 'uppercase';
        s.style.color = '#3d3d3d';
        s.style.marginTop = '2px';
        overlay.appendChild(s);
      }
    });
  }
  /*  SYNC TO GALLERY & ZOOM MODAL (Main Displays) */

  function syncPlaqueTextToGallery() {
    const enabled = !document.getElementById('addon-plaque-id')?.disabled;
    if (!enabled) return;

    const wrappers = document.querySelectorAll('.cc_city-preview-wrapper, .city-preview-wrapper');

    wrappers.forEach(w => {
      /*  One overlay per cube, each reading the slot for the city it sits under. */
      w.querySelectorAll('.plaque-overlay').forEach(plaque => {
      const inner = plaque.querySelector('.plaque-overlay-inner');
      if (!inner) return;

      const slot = plaque.dataset.cityIndex || '1';
      const headlineInput = document.getElementById(`plaque-note-${slot}`);
      const subInput = document.getElementById(`plaque-subnote-${slot}`);
      
      inner.innerHTML = '';
      /*  Use actual plaque container width for font math */
      const widthPx = plaque.clientWidth || 150;
      const headlineSize = widthPx * 0.06;
      const subSize = widthPx * 0.03;

      const rawHeadline = headlineInput?.value.trim() || '';
      const previewHeadline = rawHeadline.toUpperCase().replace(/❤️|❤|♥/g, '♡');

      const h = document.createElement('span');
      h.className = 'plaque-text-head';
      h.textContent = previewHeadline;
      h.style.fontSize = `${headlineSize}px`;
      h.style.fontWeight = 'bold';
      h.style.lineHeight = '1';
      h.style.textTransform = 'uppercase';
      h.style.color = '#3d3d3d';
      inner.appendChild(h);

      if (subInput && subInput.value.trim()) {
        const rawSub = subInput.value.trim();
        const previewSub = rawSub.toUpperCase().replace(/❤️|❤|♥/g, '♡');
        const s = document.createElement('span');
        s.className = 'plaque-text-sub';
        s.textContent = previewSub;
        s.style.fontSize = `${subSize}px`;
        s.style.lineHeight = '1';
        s.style.textTransform = 'uppercase';
        s.style.color = '#3d3d3d';
        s.style.marginTop = '1px';
        inner.appendChild(s);
      }
      /*  Handle character scaling (SQUISHING) so text fits metal plate */
      requestAnimationFrame(() => {
        const maxW = plaque.clientWidth;
        if (!maxW) return;
        const headEl = inner.querySelector('.plaque-text-head');
        const subEl = inner.querySelector('.plaque-text-sub');
        if (!headEl) return;

        headEl.style.transform = '';
        if (subEl) subEl.style.transform = '';

        const wHead = headEl.offsetWidth;
        const wSub = subEl ? subEl.offsetWidth : 0;
        const widest = Math.max(wHead, wSub);
        
        if (widest > maxW && widest > 0) {
          const scale = (maxW / widest) * 0.95;
          inner.style.transform = `scale(${scale})`;
          inner.style.transformOrigin = 'center';
        } else {
          inner.style.transform = '';
        }
      });
      });
    });
  }

  function syncPlaquePreviewVisibility(activeCount) {
    const plaqueEnabled = !document.getElementById('addon-plaque-id')?.disabled;
    for (let i = 1; i <= 6; i++) {
      const container = document.querySelector(`.preview-container-${i}`);
      if (container) {
        container.style.display = (plaqueEnabled && i <= activeCount) ? '' : 'none';
      }
    }
  }
  /*  EMOJI & SYMBOL VALIDATION */

  function validatePlaqueInput(input) {
    const originalValue = input.value;
    let protectedValue = originalValue
      .replace(/❤️/g, '___HEART_EMOJI___')
      .replace(/❤/g, '___HEART_CHAR___')
      .replace(/♥/g, '___HEART_PLAIN___');

    let cleaned = protectedValue
      .replace(/[\u{1F600}-\u{1F64F}]/gu, '')
      .replace(/[\u{1F300}-\u{1F5FF}]/gu, '')
      .replace(/[\u{1F680}-\u{1F6FF}]/gu, '')
      .replace(/[\u{1F1E0}-\u{1F1FF}]/gu, '')
      .replace(/[\u{1F900}-\u{1F9FF}]/gu, '')
      .replace(/[\u{1FA00}-\u{1FAFF}]/gu, '')
      .replace(/[\u{2600}-\u{26FF}]/gu, '')
      .replace(/[\u{2700}-\u{27BF}]/gu, '')
      .replace(/[\u{FE00}-\u{FE0F}]/gu, '')
      .replace(/\|/g, '');

    cleaned = cleaned
      .replace(/___HEART_EMOJI___/g, '❤️')
      .replace(/___HEART_CHAR___/g, '❤')
      .replace(/___HEART_PLAIN___/g, '♥');

    if (originalValue.replace(/❤️|❤|♥/g, '') !== cleaned.replace(/❤️|❤|♥/g, '')) {
      input.value = cleaned;
      showPlaqueError(input);
      return false;
    }
    return true;
  }

  function showPlaqueError(inputElement) {
    let popup = document.getElementById('plaque-error-popup');
    if (!popup) {
      popup = document.createElement('div');
      popup.id = 'plaque-error-popup';
      Object.assign(popup.style, {
        position: 'fixed', backgroundColor: '#fff', color: '#333',
        padding: '12px 16px', borderRadius: '8px', boxShadow: '0px 4px 16px rgba(0,0,0,0.15)',
        border: '1px solid #e5e5e5', fontSize: '13px', zIndex: '999999', pointerEvents: 'none'
      });
      popup.textContent = window.CF.T.plaque_error.emoji_not_allowed;
      document.body.appendChild(popup);
    }
    const rect = inputElement.getBoundingClientRect();
    popup.style.left = `${rect.left}px`;
    popup.style.top = `${rect.bottom + 8}px`;
    popup.style.display = 'block';
    setTimeout(() => { popup.style.display = 'none'; }, 3000);
  }
  /*  AUTO-FILL & EVENTS */

  function applyAutoFill() {
    const autoHeadEl = document.getElementById('auto-headline');
    const autoSubEl = document.getElementById('auto-subheadline');
    if (!autoHeadEl || !autoSubEl) return;

    const active = getActiveCityCount();
    for (let i = 1; i <= active; i++) {
      const v = getVariantForSlot(i);
      const hIn = document.getElementById(`plaque-note-${i}`);
      const sIn = document.getElementById(`plaque-subnote-${i}`);
      if (!hIn || !sIn || !v) continue;

      if (autoHeadEl.value === 'cityname') hIn.value = v.baseCity || '';
      if (autoHeadEl.value === 'cityname_local') hIn.value = v.localname || v.baseCity || '';
      if (autoHeadEl.value === 'cityname_english') hIn.value = v.englishName || v.baseCity || '';
      if (autoHeadEl.value === 'countryname') hIn.value = stripFlagEmoji(v.countryname || '');
      if (autoHeadEl.value === 'cityname+countrycode') hIn.value = v.baseCity ? `${v.baseCity}, ${v.countrycode || ''}`.trim() : '';

      if (autoSubEl.value === 'cityname') sIn.value = v.baseCity || '';
      if (autoSubEl.value === 'cityname_local') sIn.value = v.localname || v.baseCity || '';
      if (autoSubEl.value === 'cityname_english') sIn.value = v.englishName || v.baseCity || '';
      if (autoSubEl.value === 'countryname') sIn.value = stripFlagEmoji(v.countryname || '');
      if (autoSubEl.value === 'areaname') sIn.value = v.variantCity || '';
      if (autoSubEl.value === 'coordinates') sIn.value = v.coordinates || '';
      if (autoSubEl.value === 'scale') sIn.value = v.scale || '';
      if (autoSubEl.value === 'none') sIn.value = '';

      updatePlaqueModalPreview(i);
    }
    syncPlaqueTextToGallery();
  }
  /*
    An auto-fill option is worth offering if it resolves to something distinct for
    ANY city in the Set — the CUBE page could decide this from its single city, but
    hiding "City Name (Local)" here because Athens has no local name would take it
    away from Cairo too. Only hide an option when it is redundant for all of them.
  */
  function refreshAutofillOptions() {
    const active = getActiveCityCount();
    const variants = [];
    for (let i = 1; i <= active; i++) {
      const v = getVariantForSlot(i);
      if (v) variants.push(v);
    }
    if (!variants.length) return;

    const anyLocal = variants.some(v => {
      const base = (v.baseCity || '').trim();
      return v.localname && v.localname.trim() !== base;
    });
    const anyEnglish = variants.some(v => {
      const base = (v.baseCity || '').trim();
      return v.englishName && v.englishName.trim() !== base;
    });
    const anyArea = variants.some(v => v.variantCity && v.variantCity.trim());

    ['auto-headline', 'auto-subheadline'].forEach((id) => {
      const sel = document.getElementById(id);
      if (!sel) return;
      const locOpt = sel.querySelector('option[value="cityname_local"]');
      const engOpt = sel.querySelector('option[value="cityname_english"]');
      if (locOpt) { locOpt.hidden = !anyLocal; if (!anyLocal && sel.value === 'cityname_local') sel.value = ''; }
      if (engOpt) { engOpt.hidden = !anyEnglish; if (!anyEnglish && sel.value === 'cityname_english') sel.value = ''; }
    });
    /*  "Area name" lives only in the subheadline select. */
    const subSel = document.getElementById('auto-subheadline');
    const areaOpt = subSel && subSel.querySelector('option[value="areaname"]');
    if (areaOpt) { areaOpt.hidden = !anyArea; if (!anyArea && subSel.value === 'areaname') subSel.value = ''; }
  }

  function bindEventHandlers() {
    for (let i = 1; i <= 6; i++) {
      const hIn = document.getElementById(`plaque-note-${i}`);
      const sIn = document.getElementById(`plaque-subnote-${i}`);
      if (hIn) hIn.addEventListener('input', () => { validatePlaqueInput(hIn); updatePlaqueModalPreview(i); syncPlaqueTextToGallery(); });
      if (sIn) sIn.addEventListener('input', () => { validatePlaqueInput(sIn); updatePlaqueModalPreview(i); syncPlaqueTextToGallery(); });
    }
    const ah = document.getElementById('auto-headline');
    const as = document.getElementById('auto-subheadline');
    if (ah) ah.addEventListener('change', applyAutoFill);
    if (as) as.addEventListener('change', applyAutoFill);
  }

  window.CFPlaque = {
    init() {
      if (PlaqueModule.initialized) return;
      bindEventHandlers();
      const designBtn = document.getElementById('plaque-design-btn');
      if (designBtn) designBtn.addEventListener('click', () => {
        setTimeout(() => {
          const count = getActiveCityCount();
          syncPlaquePreviewVisibility(count);
          refreshAutofillOptions();
          updatePlaqueModalPreview(1);
        }, 50);
      });
      PlaqueModule.initialized = true;
    },
    updatePreview: (i) => updatePlaqueModalPreview(i),
    syncToGallery: () => syncPlaqueTextToGallery(),
    updateVisibility: (count) => syncPlaquePreviewVisibility(count),
    applyAutoFill: () => applyAutoFill(),
    getGalleryConfig: (size, isMobile) => PlaqueModule.getConfig().gallery[isMobile ? 'mobile' : 'desktop'] || {},
    /*
      The plaque designer's window (assets/cf-plaque-designer.js, a plate per city) adds, changes or removes the
      plaques through these: the material ('none' without), setting it, and the Set's cities by slot - a slot still
      to fill as null - whose plates it shows and fills.
    */
    material: () => (window.CF.STATE.choices.plaque ? window.CF.STATE.plaqueMaterial || 'steel' : 'none'),
    setMaterial: (mat) => {
      if (mat === 'steel' || mat === 'brass') {
        window.CF.STATE.plaqueMaterial = mat;
        setPlaque(mat, false);
      } else {
        setPlaque('none', false);
      }
    },
    places: () => Array.from({ length: window.CF.SET.count }, (_, i) => {
      const id = document.getElementById(`City${i + 1}`)?.value;
      return (id && window.CF_VARIANT_LOOKUP?.byId?.[String(id)]) || null;
    })
  };

  /*
    The cover's window (assets/cf-cover-window.js) the same way: the cover chosen and choosing one, one per city -
    how many - and the CUBE it shows under the cover, the first city's.
  */
  window.CFCover = {
    get: () => getSelectedDisplayCover(),
    set: (cover) => setDisplayCover(cover),
    count: () => window.CF.SET.count,
    model: () => (window.CF.SET_CITIES || []).find((c) => c && c.image)?.image || ''
  };

})();
  
function showError(message) {
  document.querySelectorAll('.error-note').forEach(el => {
    el.textContent = message;
    el.style.display = 'block';
  });
}

function clearError() {
  document.querySelectorAll('.error-note').forEach(el => {
    el.textContent = '';
    el.style.display = 'none';
  });
}

function validateSelections() {
  /*
    THE CITIES, NOT THE SIZE VARIANT. #SetVariant is held at zero inventory on
    purpose — it is the line the cart transform merges into, and nothing may
    add it directly — so a stock test on it would call every Set sold out.
    What is or is not in stock is the cities the shopper chose.
  */
  const chosen = window.CF.SET_CITIES || [];

  if (chosen.filter(c => c && c.id).length !== setCount()) {
    return { valid: false, message: window.CF.T.validation.select_city };
  }
  /*
    The same test, on the same cities, as updateAddToCartState — an
    unresolvable id counts as out of stock in both, so the button state and
    this can never disagree about whether the Set may be bought.
  */
  if (cfSetOutOfStock(chosen)) {
    return { valid: false, message: window.CF.T.validation.city_out_of_stock };
  }
  /*
    Plaque text required only if the plaque add-on is enabled.
    Surfaced as a native browser alert rather than the inline
    `.error-note` paragraph above the ATC button: the empty plaque
    text is far enough up the form (inside the customise-plaque modal,
    typically out of view by the time the user clicks Add to Cart)
    that a quiet inline message reads as silent failure. The alert
    forces an acknowledgement and tells the user where to look.

    A HEADLINE FOR EVERY CITY (2026-10-02). The price counts a plaque per city and the cart adds one per city with
    words, so a Set of four with words for the first city only was quoted four plaques and given one.
  */
  if (window.CF.STATE.choices.plaque === true) {
    for (let i = 1; i <= setCount(); i++) {
      const headline = document.getElementById(`plaque-note-${i}`);
      if (!headline || !headline.value.trim()) {
        return { valid: false, message: window.CF.T.validation.enter_plaque_text, kind: 'alert' };
      }
    }
  }

  return { valid: true, message: null };
}
  

function updateAddToCartState() {
  const buttons = allATC();
  /*
    Every slot the Set holds has to be filled: an empty fourth row is a city still to choose, not a Set of three.
  */
  const chosen = (window.CF.SET_CITIES || []).filter(Boolean);
  const unstocked = chosen.length === setCount() && cfSetOutOfStock(chosen);
  const blocked = chosen.length !== setCount() || unstocked;

  buttons.forEach(btn => {
    btn.disabled = blocked;
    btn.classList.toggle('disabled', blocked);
    btn.classList.toggle('enabled', !blocked);
    btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    btn.style.opacity = blocked ? '0.5' : '1';
    btn.style.cursor = blocked ? 'not-allowed' : 'pointer';
  });
  /*
    A full Set the shelf cannot fill says why its button is off: the picker marks a city out of stock on its own,
    but not one chosen in more slots than are left.
  */
  const stockNote = window.CF.T.validation.city_out_of_stock;
  if (unstocked) {
    showError(stockNote);
  } else if (!blocked || document.querySelector('.error-note')?.textContent === stockNote) {
    clearError();
  }
}

async function handleAddToCart(e) {

  e.preventDefault();
  const { valid, message, kind } = validateSelections();
  if (!valid) {
    /*
      `kind: 'alert'` opts the message into a native browser dialog
      (currently only the plaque-text-required error uses it — see
      validateSelections). Everything else falls through to the
      inline .error-note paragraph above the Add-to-Cart button.
    */
    if (kind === 'alert') {
      alert(message);
    } else {
      showError(message);
    }
    return;
  }

  const buttons = allATC();
  if (!buttons.length) return;

  lockATCButtons(true, window.CF.T.atc.adding);

  try {
    await CFCities.resolveHeights((window.CF.SET_CITIES || []).map(c => c && c.id));
    const items = buildCartItems();
    if (!items) {
      /*
        A slot can hold a design whose product has gone, and a dead button with
        no message reads as the site being broken.
      */
      lockATCButtons(false);
      showError(window.CF.T.atc.error_generic);
      return;
    }

    await postCartItems(items);
    /*  In the cart now: the next visit builds a new Set (CFSetPicker, "THE SET IS KEPT"). */
    CFSetPicker.forget();

    document.dispatchEvent(new Event('cart:refresh'));

    openCartDrawerOrRedirect();

  } catch (err) {
    console.error('Add to cart failed', err);
    /*  An add past a cover's or plaque's stock is refused with its own message (assets/cf-addon-stock.js). */
    alert((window.CFAddonStock && window.CFAddonStock.takeMessage()) || window.CF.T.atc.error_generic);
  } finally {
    lockATCButtons(false);
  }
}

async function postCartItems(items) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      items: items,
      attributes: {
        'cube_configurator': 'true'
      }
    })
  });
  
  if (!res.ok) {
    const errJson = await res.json().catch(()=>({}));
    throw new Error(errJson.description || res.statusText);
  }
  return res.json();
}


  function lockATCButtons(disabled, label) {
  allATC().forEach(btn => {
    btn.disabled = disabled;
    if (label) btn.innerText = label;
    else btn.innerText = window.CF.T.atc.add_to_cart;
    btn.classList.toggle('disabled', disabled);
    btn.classList.toggle('enabled', !disabled);
    btn.style.opacity = disabled ? '0.5' : '1';
    btn.style.cursor  = disabled ? 'not-allowed' : 'pointer';
  });
}

function buildCartItems() {
  const items = [];
  /*
    City presence + stock are guaranteed at this point by
    validateSelections() — handleAddToCart bails before calling us
    when either fails. The two `alert()` re-checks that used to live
    here ("Please choose a city.", "This city is out of stock.") were
    unreachable, hardcoded in English, and would have leaked into
    non-English storefronts if they ever did fire.
  */
  const chosen = (window.CF.SET_CITIES || []).filter(c => c && c.id);
  /*
    A CUBE LINE PER CITY, ONE SHARED MARK — not one parent line carrying the ids.
    The cart transform merges: lines sharing a `_set` value become a single line
    on the size's variant, at their sum less the Set's amount for that size, so a
    clearance city in the Set is discounted from ITS price and the size variants
    stay unbuyable on their own. One id per configurator run, so a plaque added
    beside it is never swept in and two Sets in one cart stay two lines.

    A LINE PER SLOT, EVEN FOR THE SAME CITY TWICE (2026-10-02). Shopify folds lines with the same variant and the
    same properties into one, so Berlin in two slots arrived as one line of 2 — and the transform reads how many
    Sets a group holds off the greatest common divisor of its quantities (a Set raised to two comes back as every
    line doubled). Berlin four times read as four Sets of one, and three cities twice each as two Sets of three:
    no Set price at all, or the 3-city price twice, €340 or €430 where the page said €280 or €410. `_slot`, hidden
    like `_set`, keeps every slot its own line of 1.
  */
  if (chosen.length !== setCount()) return null;
  const setId = `s${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  for (let i = 0; i < chosen.length; i++) {
    /*
      A slot can hold a custom location, which is a different product carrying
      the design as properties. CFCities.lineItem knows both shapes and is
      shared with the bundle configurator, so an order reads the same whichever
      surface placed it — and returns null rather than a NaN id for a design
      whose product has gone.
    */
    const c = chosen[i];
    const line = CFCities.lineItem(cfGetVariantById(c.id) || { id: c.id }, { _set: setId, _slot: String(i + 1) });
    if (!line) return null;
    items.push(line);
  }
  /*
    The add-ons come once per city: a cover for each, and a plaque per city
    carrying that city's own engraving.
  */
  const cover = getSelectedDisplayCover();
  if (cover === 'acrylic') {
    items.push({ id: parseInt(window.CF.PRODUCT_DATA.cover.acrylicId, 10), quantity: addonQty() });
  } else if (cover === 'glass') {
    items.push({ id: parseInt(window.CF.PRODUCT_DATA.cover.glassId, 10), quantity: addonQty() });
  }

  const plaqueIdEl = document.getElementById('addon-plaque-id');
  if (plaqueIdEl && !plaqueIdEl.disabled) {
    const cities = window.CF.SET_CITIES || [];
    for (let i = 1; i <= setCount(); i++) {
      const head = document.getElementById(`plaque-note-${i}`)?.value.trim() || '';
      const sub  = document.getElementById(`plaque-subnote-${i}`)?.value.trim() || '';
      if (!head) continue;
      const props = { 'Headline': head, 'City': cities[i - 1]?.title || '' };
      if (sub) props['Sub-Headline'] = sub;
      items.push({ id: parseInt(plaqueIdEl.value, 10), quantity: 1, properties: props });
    }
  }

  return items;
}

function openCartDrawerOrRedirect() {

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  } else {
    window.location.href = '/cart';
  }
}
  /*  5. ADDITIONAL FUNCTIONS */

function updateDisplayCoverQuantities(count, displayCover) {
  const acrylicId  = document.getElementById('addon-acrylic-id');
  const acrylicQty = document.getElementById('addon-acrylic-qty');
  const glassId    = document.getElementById('addon-glass-id');
  const glassQty   = document.getElementById('addon-glass-qty');

  if (acrylicId && acrylicQty) {
    if (displayCover === 'acrylic' && count > 0) {
      acrylicId.disabled  = false;
      acrylicQty.disabled = false;
      acrylicQty.value    = count;
    } else {
      acrylicId.disabled  = true;
      acrylicQty.disabled = true;
      acrylicQty.value    = 0;
    }
  }

  if (glassId && glassQty) {
    if (displayCover === 'glass' && count > 0) {
      glassId.disabled  = false;
      glassQty.disabled = false;
      glassQty.value    = count;
    } else {
      glassId.disabled  = true;
      glassQty.disabled = true;
      glassQty.value    = 0;
    }
  }
}


function cfPreloadOverlays() {
  const overlays = window.CF.PRODUCT_DATA?.overlay || {};
  [overlays.acrylic, overlays.glass].forEach((url) => {
    if (!url) return;

    const img = new Image();
    img.decoding = 'async';
    img.onload = () => window.cfMarkOverlayLoaded(url);
    img.src = url;
  });
}
/*
  THE PICKER — the Set's slots, and the cities in them
  The one job here is to keep window.CF.SET_CITIES true. Everything else on
  this page already reads it: the price, the gallery, the plaque labels and the
  cart payload. So this module owns the selection and the Set's size, writes
  them into SET_CITIES and window.CF.SET, and then asks the page to repaint —
  it never reaches into any of those consumers itself
  The control is a searchable picker per slot, each writing the slot's own
  hidden City input — so there is no separate copy of the selection to keep in
  step. This reads those inputs, rebuilds SET_CITIES from them, and repaints
*/
const CFSetPicker = (() => {
  /*
    The City inputs are the state. Reading them on demand rather than
    mirroring them into an array is the whole reason one control per slot is
    simpler than one multi-select over all of them: there is one copy, so it
    cannot drift. An unchosen slot is '' and stays in place — slot 2 empty with
    slots 1 and 3 filled is a real, renderable state here.

    THE SET (2026-10-01): six inputs, of which the first SET.count are the Set.
    The rest stay empty while their rows are hidden, so a hidden slot never
    reaches the price, the plaque auto-fill or the cart.
  */
  const SET = window.CF.SET;
  const allInputs = () => Array.from({ length: SET.max }, (_, i) => document.getElementById(`City${i + 1}`));
  const slotInputs = () => allInputs().slice(0, SET.count);
  const pickers = () => Array.from(document.querySelectorAll('[data-trio-slot]'));
  const selection = () => slotInputs().map(input => input?.value || '');
  let lastSelection = [];
  /*
    ONE FILTER FOR EVERY FIELD, AND WHERE A LIST OPENS (2026-10-03). The bestseller and new buttons are one
    choice for the whole Set: turned on in one field, they are on in every field until turned off — the
    pickers read it from here as they open (cf-city-picker.js, `filter`). And a field's list opens at its own
    city or, an empty one, at the city chosen last (`startAt`), so the next pick near it is not a scroll down
    from A. The last choice is the newest city chosen in any field; before one is, the last city in the Set,
    so a Set put back from a visit before starts there too.
  */
  let sharedFilter = '';
  let lastPicked = '';
  const startAt = (input) => input.value || lastPicked || selection().filter(Boolean).pop() || '';

  function el(sel, root) { return (root || document).querySelector(sel); }

  function variantFor(id) {
    return id ? cfGetVariantById(id) : null;
  }
  /*
    The label the slot row shows: the picker's own row text, minus the
    decorations that only make sense in a list of 229.
  */
  function slotLabel(v) {
    if (!v) return '';
    let name = v.baseCity || v.title || '';
    if (v.localname && v.localname !== v.baseCity) name += ' / ' + v.localname;
    if (v.variantCity) name += ' - ' + v.variantCity;
    return name;
  }
  /*
    THE HANDOFF TO THE REST OF THE PAGE. SET_CITIES is rebuilt from scratch
    every time, in slot order, one entry per slot of the Set, with the empty
    ones kept as null so the gallery and the plaque can tell a slot still to
    fill from a smaller Set.
  */
  function publish() {
    window.CF.SET_CITIES = selection().map(id => {
      const v = variantFor(id);
      if (!v) return null;
      return {
        id: v.id,
        title: slotLabel(v),
        price: Number(v.priceCents) || 0,
        compareAt: Number(v.compareCents) || null,
        image: v.imgPreview || v.imgFull || ''
      };
    });
  }
  /*
    THE GALLERY. One card per slot, filled from the same state everything else
    reads. The empty frame is always the card's background; a city fades in
    over it (see theme.css, "A CITY FADES IN OVER ITS EMPTY FRAME"):

      its preview first, faded in once it has loaded, the frame pulsing
        until then;
      then its full-size picture, on a layer of its own above the preview
        (.cf-set-hi), faded in once that has loaded too.

    Nothing visible changes its source, which is what made the old swap blink.
    A slot that changes city fades back to the frame and the next one comes in
    over it; every callback first checks the slot still holds the city it was
    loading, so a quick second pick never lands the first one's picture.
  */
  function paintCells() {
    document.querySelectorAll('[data-trio-cell]').forEach(cell => {
      const c = (window.CF.SET_CITIES || [])[Number(cell.dataset.trioCell)];
      const card = el('.cube_gallery_image_card', cell);
      const img = el('.preview_image_img', cell);
      if (!img || !card) return;

      let hi = card.querySelector('.cf-set-hi');
      if (!hi) {
        hi = document.createElement('img');
        hi.className = 'cf-set-hi';
        hi.alt = '';
        hi.setAttribute('aria-hidden', 'true');
        hi.decoding = 'async';
        card.appendChild(hi);
      }

      const id = c ? String(c.id) : '';
      if ((img.dataset.city || '') === id) return;
      img.dataset.city = id;

      img.classList.remove('is-loaded');
      hi.classList.remove('is-loaded');
      img.onload = img.onerror = hi.onload = null;

      if (!c) {
        cell.classList.add('is-empty');
        cell.classList.remove('is-loading');
        delete cell.dataset.highUrl;
        img.alt = '';
        return;
      }

      const v = variantFor(c.id);
      const low = v?.imgPreview || c.image || '';
      const full = v?.imgFull || low;
      if (!low) { cell.classList.add('is-empty'); cell.classList.remove('is-loading'); return; }

      cell.classList.add('is-loading');
      cell.dataset.highUrl = full;
      img.alt = c.title || '';
      img.dataset.imgFull = full;

      img.onload = () => {
        if (img.dataset.city !== id) return;
        cell.classList.remove('is-loading', 'is-empty');
        img.classList.add('is-loaded');
        if (full && full !== low) {
          hi.onload = () => { if (img.dataset.city === id) hi.classList.add('is-loaded'); };
          hi.src = full;
        }
      };
      img.onerror = () => { if (img.dataset.city === id) cell.classList.remove('is-loading'); };
      img.src = low;
      /*
        Moving a city up a slot (removeSlot): its pictures were on screen a moment ago, so they are ready, and
        the slot shows them at once rather than fading back to the frame first — the slot is sliding into
        place with them. Ready means decoded and in the browser's memory: then `complete` holds as soon as
        the source is set. Not ready, they fade in as any city does.
      */
      if (paintNow && img.complete && img.naturalWidth) {
        const loaded = img.onload;
        img.onload = null;
        loaded();
        if (hi.onload && hi.complete && hi.naturalWidth) {
          const hiLoaded = hi.onload;
          hi.onload = null;
          hiLoaded();
        }
      }
    });
  }
  /*
    THE ROW'S SCROLL BAR is assets/cf-set-scroll.js (snippets/cf-set-scroll), shared with the curated Sets since
    2026-10-14: it repaints when the row scrolls or resizes, and this asks it to when the Set changes size.
  */
  const row = () => document.getElementById('configurator-carousel');
  function paintScroll() { window.cfSetScroll?.paint(row()); }
  /*
    HOW MANY THE SET HOLDS, shown: as many columns — card and picker — as
    cities (each the size three get, see theme.css), the remove buttons once
    there is a city to spare, and after them the plus that adds one — or, at
    six, the same button as the way to the Collection.
  */
  function paintSize() {
    document.querySelectorAll('[data-set-slot]').forEach(slot => {
      slot.hidden = Number(slot.dataset.setSlot) >= SET.count;
    });

    el('[data-set-picker]')?.classList.toggle('is-removable', SET.count > SET.min);
    /*
      At six the plus stays and becomes the way to the Collection: its grid icon, its words (tooltip and name),
      and a click that opens the note rather than adding a city (see the markup).
    */
    const add = el('[data-set-add]');
    if (add) {
      const full = SET.count >= SET.max;
      add.classList.toggle('is-full', full);
      const label = full ? add.dataset.labelFull : add.dataset.labelAdd;
      if (label) {
        add.dataset.tooltip = label;
        const name = el('[data-set-add-label]', add);
        if (name) name.textContent = label;
      }
      if (!full) closeFullNote();
    }
    /*
      The size's own variant, in the hidden input the page has always held the product variant in, and in the
      address bar, so a reload or a shared link opens the Set at the size it was left at.
    */
    const v = SET.variants?.[SET.count];
    const variantInput = document.getElementById('SetVariant');
    if (v && variantInput && variantInput.value !== String(v.id)) {
      variantInput.value = String(v.id);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        window.history.replaceState(window.history.state, '', url);
      } catch (_) {}
    }
    /*
      At once, not a frame later: the columns above were just shown or hidden, and reading the row's widths lays it
      out on the spot.
    */
    paintScroll();
  }
  /*
    Bring a city's column into view inside the row, sideways only: the page
    itself stays where the shopper is, picking. A column already wholly in
    view is left alone, so a Set that fits never moves.
  */
  /*
    Scrolls the row to `left`, smoothly, and resolves once it stands still: at
    once when there is nowhere to go, else when the scroll has arrived — or,
    the row's snapping having moved its end, has not moved for a few frames;
    a second at most.
  */
  function scrollRow(track, left) {
    const target = Math.max(0, Math.min(left, track.scrollWidth - track.clientWidth));
    if (Math.abs(track.scrollLeft - target) < 1) return Promise.resolve();
    track.scrollTo({ left: target, behavior: 'smooth' });
    return new Promise(resolve => {
      const start = performance.now();
      let last = track.scrollLeft;
      let still = 0;
      const tick = () => {
        const elapsed = performance.now() - start;
        still = Math.abs(track.scrollLeft - last) < 0.5 ? still + 1 : 0;
        last = track.scrollLeft;
        if (Math.abs(track.scrollLeft - target) < 1 || (elapsed > 150 && still >= 4) || elapsed > 1000) resolve();
        else requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }
  /*
    A city just chosen comes into view, centred in the row, unless it is in
    view already.
  */
  function revealCell(idx) {
    const track = document.getElementById('configurator-carousel');
    const cell = track?.querySelector(`[data-set-slot="${idx}"]`);
    if (!track || !cell || cell.hidden) return Promise.resolve();
    const tr = track.getBoundingClientRect();
    const cr = cell.getBoundingClientRect();
    if (cr.left >= tr.left - 1 && cr.right <= tr.right + 1) return Promise.resolve();
    return scrollRow(track, track.scrollLeft + (cr.left - tr.left) - (tr.width - cr.width) / 2);
  }
  /*
    One made-to-order city changes what the whole Set promises. Nothing else
    to paint: a picker shows its own selection.
  */
  function paintShipping() {
    const madeToOrder = selection().some(id => id && window.CFCities?.isCustomId(id));
    window.cfShipLine?.set(madeToOrder ? 'custom_cube' : 'stock');
    window.cfShipLine?.basket(basketGrams());
  }
  /*
    WHAT THIS SET WOULD WEIGH, so the delivery line can say whether UPS Economy
    applies to it (snippets/cf-delivery-data). The page knows the cities and
    the add-ons, so it can weigh them instead of guessing from the price: a
    five-city Set is 1,750 g of small cities or 2,750 g of big ones at exactly
    the same price, and only one of those fits the 2 kg band.

    A slot still empty weighs nothing, so a half-filled Set reads as the Set it
    is so far - which is what the line beside it is describing.

    A custom location has no catalogue row and so no weight of its own; it is
    counted as the heaviest CUBE there is, because the honest answer for an
    unknown city is the one that does not over-promise.
  */
  function basketGrams() {
    const catalogue = window.CF_CUBE_VARIANTS || [];
    let heaviest = 0;
    for (const c of catalogue) heaviest = Math.max(heaviest, Number(c.weightG) || 0);
    let g = 0;
    for (const id of selection()) {
      if (!id) continue;
      if (window.CFCities?.isCustomId(id)) { g += heaviest; continue; }
      g += Number(cfGetVariantById(id)?.weightG) || 0;
    }
    for (const name of ['acrylic', 'glass', 'plaque']) {
      const idEl = document.getElementById(`addon-${name}-id`);
      const qtyEl = document.getElementById(`addon-${name}-qty`);
      if (!idEl || idEl.disabled) continue;
      g += (Number(idEl.dataset.weightG) || 0) * (Number(qtyEl?.value) || 0);
    }
    return g;
  }
  /*
    WHAT EACH SLOT IS HANDED. The element owns no state and reads no globals —
    it renders the list, tracks a selection through these accessors and says
    when that changed — so one control per slot is the same object configured
    once per row, each bound to its own City input.

    slots: () => 1 is what makes it a single-choice control: picking another
    city replaces the one in the slot instead of refusing it, and the trigger
    shows the chosen city rather than a count. See cf-city-picker.js.

    optionLines puts a row of the list, and the field once it holds that
    city, in two lines: the city as the label names it, area aside —
    "Clearance Sale: Berlin" and the rest — bold in the field, and its area
    under it.
    filters are the two buttons under the search, bestsellers and new
    cities (cf-city-picker-filters). The Collection's picker is handed the
    same two, so the two pages' lists read alike.
  */
  function configurePickers() {
    const t = window.CF.T.picker;

    pickers().forEach(picker => {
      const input = allInputs()[Number(picker.dataset.trioSlot)];
      if (!input || typeof picker.configure !== 'function') return;

      picker.configure({
        slots: () => 1,
        getSelection: () => [input.value || ''],
        setSelection: (next) => { input.value = next[0] || ''; },
        variants: () => window.CF_CUBE_VARIANTS || [],
        designs: () => (window.CFCities ? window.CFCities.readDesigns() : []),
        label: (v) => window.CFCities.label(v, t),
        optionLines: (v) => [window.CFCities.label({ ...v, variantCity: '' }, t), v.variantCity || ''],
        filters: { bestseller: (v) => v.isFavorite === true, new: (v) => v.isNew === true },
        filter: { get: () => sharedFilter, set: (key) => { sharedFilter = key; } },
        startAt: () => startAt(input),
        outOfStock: (v) => window.CFCities.isOutOfStock(v),
        t: t,
        onChange: onChange
      });
    });
  }
  /*
    THE ROW MOVES AS ITS SCROLL DOES (2026-10-02). Adding or removing a city
    changes the row at once — a column shown or hidden, the row's end where it
    was a column ago — and then every column glides from where it stood to
    where it stands now, on one curve, the way the row moves when it scrolls:
    measured before and after (moveRow), each pushed back to where it was and
    let go. Nothing jumps or blinks first; the motion is the change.

      Adding: the row goes to its end at once, where the new column is, and
        the columns slide there; the new one comes out of where the plus
        stood, fading in, and the plus goes on ahead of it. Its picker is
        left for the shopper to open.
      Removing: the cities after the one taken out each move up a slot —
        their data does, as before, so a slot keeps its inputs and its picker
        — and each slides in from the slot it had; the city taken out fades
        where it stood, a copy of its column left there for the purpose
        (ghostOf), under the one sliding over it. Its pictures swap at once
        (paintCells, paintNow): the city coming in was on screen a moment ago,
        so its pictures are ready.

    One move at a time: a click while the row is moving is let go. With
    reduced motion (the device's setting) nothing slides: the columns are at
    their new places at once, and the change is a fade — the new city fading
    in, the one taken out fading where it stood.
  */
  const MOVE_MS = 450;
  const MOVE_EASE = 'cubic-bezier(0.45, 0, 0.2, 1)';
  let moving = false;
  let paintNow = false;

  const rowItems = () => Array.from(row()?.children || []).filter(n => !n.hidden && n.matches('[data-set-slot], [data-set-add]'));
  const slotEl = (i) => el(`[data-set-slot="${i}"]`);
  const stillMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function positions() {
    const at = new Map();
    rowItems().forEach(n => at.set(n, n.getBoundingClientRect().left));
    return at;
  }
  /*
    Each item of the row from the left it had to where it is now. `from(item)`
    gives that left, or { x, enter: true } for one that was not there and fades
    in on its way, or null for one with nowhere to come from, which comes in
    from a column to its right, fading. Resolves once all of them are still.

    The row's snapping is off while they move: a column pushed back to where it
    was is, to the browser, a column in a new place, and it would snap the row
    to it and glide the row back to its start under the moving columns.
  */
  function moveRow(from, ghost) {
    const track = row();
    if (!track) return Promise.resolve();
    const step = (slotEl(0)?.getBoundingClientRect().width || 0) + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const still = stillMotion();
    const timing = { duration: MOVE_MS, easing: MOVE_EASE };
    const fade = { duration: 250, easing: 'ease-out' };
    track.classList.add('is-moving');
    track.style.scrollSnapType = 'none';
    const runs = rowItems().map(n => {
      const now = n.getBoundingClientRect().left;
      let was = from(n);
      let enter = false;
      if (was && typeof was === 'object') { enter = Boolean(was.enter); was = was.x; }
      if (was == null) { was = now + step; enter = true; }
      const dx = was - now;
      if (enter && still) return n.animate([{ opacity: 0 }, { opacity: 1 }], fade).finished;
      if (enter) {
        return n.animate([{ transform: `translateX(${dx}px)`, opacity: 0 }, { transform: 'none', opacity: 1 }], timing).finished;
      }
      if (still || Math.abs(dx) < 0.5) return Promise.resolve();
      return n.animate([{ transform: `translateX(${dx}px)` }, { transform: 'none' }], timing).finished;
    });
    if (ghost) {
      const at = `translateX(${ghost.dx()}px)`;
      runs.push(ghost.node.animate(still
        ? [{ transform: at, opacity: 1 }, { transform: at, opacity: 0 }]
        : [{ transform: at, opacity: 1 }, { transform: `${at} scale(0.96)`, opacity: 0 }],
      still ? fade : { ...timing, duration: MOVE_MS * 0.7 }).finished.then(() => ghost.node.remove()));
    }
    return Promise.all(runs.map(r => r.catch(() => {}))).then(() => {
      ghost?.node.remove();
      track.classList.remove('is-moving');
      track.style.scrollSnapType = '';
      paintScroll();
    });
  }
  /*
    A still copy of a column, over the column, in the row: what fades where a
    removed city stood. Nothing in it answers to the page — no ids, no data
    the page looks things up by, its picker never configured.
  */
  function ghostOf(slot) {
    const track = row();
    if (!slot || !track) return null;
    const node = slot.cloneNode(true);
    node.removeAttribute('data-set-slot');
    node.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
    node.querySelectorAll('[data-bcv2-ms-panel]').forEach(n => n.remove());
    node.querySelectorAll('[data-trio-cell], [data-trio-slot]').forEach(n => { n.removeAttribute('data-trio-cell'); n.removeAttribute('data-trio-slot'); });
    node.classList.add('cf-set-ghost');
    node.setAttribute('aria-hidden', 'true');
    node.style.left = slot.offsetLeft + 'px';
    node.style.top = slot.offsetTop + 'px';
    node.style.width = slot.offsetWidth + 'px';
    const was = slot.getBoundingClientRect().left;
    track.appendChild(node);
    return { node, dx: () => was - node.getBoundingClientRect().left };
  }
  /*
    ONE MORE CITY, from the plus — see "THE ROW MOVES" above. The search is
    left alone, as with any click on a field (cf-city-picker.js); from the
    keyboard it takes the focus.
  */
  function addSlot(e) {
    if (SET.count >= SET.max || moving) return;
    const track = row();
    const idx = SET.count;
    const before = positions();
    const add = el('[data-set-add]');
    const addWas = before.get(add);
    if (track) track.style.scrollSnapType = 'none';

    const input = allInputs()[idx];
    if (input) input.value = '';
    SET.count += 1;
    pickers()[idx]?.refresh?.();
    onChange();
    if (track) track.scrollLeft = track.scrollWidth;

    const slot = slotEl(idx);
    const fromKeyboard = e?.detail === 0;
    moving = true;
    moveRow(n => (n === slot ? (addWas == null ? null : { x: addWas, enter: true }) : (before.get(n) ?? null))).then(() => {
      moving = false;
      /*
        The list is not opened for the shopper: the new column is there to see first, and its field to click.
        From the keyboard the focus goes on to that field, so the next key opens it.
      */
      if (fromKeyboard && SET.count > idx) el('.bcv2-ms-trigger', pickers()[idx])?.focus();
    });
  }
  /*
    SIX CITIES: THE NOTE. Over the button at six, a line saying a Set holds six
    and pointing to the Collection for more — opened and closed by the button,
    closed by a click elsewhere or Escape, and whenever the Set is under six. It
    sits in the row, so it scrolls with the button; placed over it, right-aligned
    to it, inside the row.
  */
  const fullNote = () => el('[data-set-full-note]');

  function closeFullNote() {
    const note = fullNote();
    if (!note || note.hidden) return;
    note.hidden = true;
    el('[data-set-add]')?.setAttribute('aria-expanded', 'false');
  }

  function toggleFullNote() {
    const note = fullNote();
    const add = el('[data-set-add]');
    if (!note || !add) return;
    if (!note.hidden) { closeFullNote(); return; }
    note.hidden = false;
    add.setAttribute('aria-expanded', 'true');
    const left = add.offsetLeft + add.offsetWidth - note.offsetWidth;
    note.style.left = Math.max(8, left) + 'px';
    note.style.top = Math.max(0, add.offsetTop - note.offsetHeight - 8) + 'px';
  }
  /*
    ONE CITY LESS, from anywhere in the Set: the cities after it move up a
    row. Their engravings go with them - the plaque designer moves each
    plaque's words to its city's new slot (cf:set-change, assets/
    cf-plaque-designer.js) - so a plaque never ends up under a different city
    from the one it was written for.
  */
  function removeSlot(idx) {
    if (SET.count <= SET.min || idx >= SET.count || moving) return;
    const before = positions();
    const count = SET.count;
    const slots = Array.from({ length: count }, (_, i) => slotEl(i));
    const add = el('[data-set-add]');
    const ghost = ghostOf(slots[idx]);
    const track = row();
    if (track) track.style.scrollSnapType = 'none';

    const inputs = allInputs();
    for (let i = idx; i < SET.count - 1; i++) inputs[i].value = inputs[i + 1].value;
    inputs[SET.count - 1].value = '';
    SET.count -= 1;
    pickers().forEach(p => p.refresh?.());
    paintNow = true;
    try { onChange(); } finally { paintNow = false; }

    moving = true;
    moveRow(n => {
      if (n === add) return before.get(add) ?? null;
      const i = slots.indexOf(n);
      if (i < 0) return null;
      return before.get(i < idx ? slots[i] : slots[i + 1]) ?? null;
    }, ghost).then(() => { moving = false; });
  }
  /*
    Called whenever a slot's city changes, and after a row comes or goes. A
    hidden input does not fire `change` when script writes to it, so this is
    the picker's onChange rather than a listener on the inputs.
  */
  function onChange() {
    const before = lastSelection;
    publish();
    paintSize();
    paintShipping();
    paintCells();
    /*
      The plaque auto-fill reads the City inputs, so it has to run after
      publish() — a city added to slot 3 has to reach the third engraving.
    */
    if (window.CFPlaque?.applyAutoFill) window.CFPlaque.applyAutoFill();
    updateUI();
    /*
      A city just chosen comes into view in the row — not the cities a removal moves up a slot, which the row's
      own motion places (removeSlot): scrolling to them as well glided the row away under the moving columns.
    */
    const now = selection();
    const changed = now.findIndex((id, i) => id && id !== before[i]);
    if (changed > -1 && !paintNow) {
      revealCell(changed);
      lastPicked = now[changed];
    }
    lastSelection = now;
    save();
    /*
      For the tracking script (assets/cf-tracking.js): the Set as the shopper has just left it — its size and the
      city in each slot, '' for an empty one. Only from here, a shopper's change, never from the restore on load.
    */
    document.dispatchEvent(new CustomEvent('cf:set-change', { detail: { count: SET.count, cities: now } }));
  }
  /*
    THE SET IS KEPT FOR THE VISITOR (2026-10-02): its size and cities, its
    display cover, its engraving — steel, brass or none — and the engraving's
    words, with the two auto-fill choices they came from, in this browser's
    localStorage, so leaving the page — to look at a city, to the cart, for a
    day — no longer starts the Set over. Not sessionStorage: a session ends with
    its tab, and a link opened in a new one starts another. Seven days, then it
    is dropped; and dropped once it is in the cart, so the next visit builds a
    new Set rather than finding the bought one.

    Written on what the shopper does — a city chosen, added or removed (onChange),
    a cover or an engraving picked (setDisplayCover, setPlaque), a line typed or
    an auto-fill chosen (the listener in init) — not on every repaint, so a
    repaint after Add to cart cannot write the bought Set back.

    Read back in two steps. The size and the cities first (restore, as the page
    opens), since the rest of the page is built from them. The cover, the
    engraving and its words last (restoreExtras, from the page's init, after
    the plaque's own auto-fill), so the words written are the ones kept, not the
    auto-fill's; and quietly — the page's own setters, without the jump to the
    main picture or the analytics event a click sends.

    A size in the address bar wins over the saved one — it is a reload (the page
    writes its own) or a link to a size — and the saved cities fill that many
    slots. A city the page no longer knows (a design gone from this browser, a
    variant gone from the catalogue) is left out and its slot stays empty; one
    out of stock is kept, and the Add to cart check says so, rather than
    vanishing without a word. Storage can be refused (a private window, a full
    or blocked store): then nothing is kept, as before.
  */
  const SAVE_KEY = 'cf-set-config';
  const SAVE_MS = 7 * 24 * 60 * 60 * 1000;
  const COVERS = ['none', 'acrylic', 'glass'];
  const PLAQUES = ['none', 'steel', 'brass'];
  const PLAQUE_FIELDS = '[id^="plaque-note-"], [id^="plaque-subnote-"], #auto-headline, #auto-subheadline';
  let kept = null;
  let ready = false;
  let saveTimer = 0;

  function plaqueWords() {
    return Array.from({ length: SET.max }, (_, i) => [
      document.getElementById(`plaque-note-${i + 1}`)?.value || '',
      document.getElementById(`plaque-subnote-${i + 1}`)?.value || ''
    ]);
  }

  function save() {
    if (!ready) return;
    clearTimeout(saveTimer);
    const state = window.CF.STATE || {};
    try {
      localStorage.setItem(SAVE_KEY, JSON.stringify({
        v: 1,
        at: Date.now(),
        count: SET.count,
        cities: selection(),
        cover: state.choices?.cover || 'none',
        plaque: state.choices?.plaque ? (state.plaqueMaterial || 'steel') : 'none',
        auto: [document.getElementById('auto-headline')?.value ?? null, document.getElementById('auto-subheadline')?.value ?? null],
        words: plaqueWords()
      }));
    } catch (_) {}
  }

  function saveSoon() {
    if (!ready) return;
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 300);
  }

  function forget() {
    clearTimeout(saveTimer);
    try { localStorage.removeItem(SAVE_KEY); } catch (_) {}
  }
  /*
    A LINK WITH ITS CITIES (2026-10-14): /products/cube-set-individual?cities=<id>,<id>,… opens the builder with those cities
    in its slots, at the size of their number (three to six) - a curated Set's "Customize this Set" sends its own,
    so the customer starts from that Set and swaps a city rather than starting empty. It wins over a saved Set
    (whose covers and plaques it does not bring either); the next change saves over that as usual. It comes off
    the address bar once read, so a reload keeps what was changed since rather than starting over. A city the
    page does not know leaves its slot empty. A Custom Location design comes as `custom:<design id>` (the Set offer
    window on its page, 2026-10-25) and is found like any city: the page lists this browser's saved designs.
  */
  function fromLink() {
    let url = null;
    try { url = new URL(window.location.href); } catch (_) { return false; }
    const raw = url.searchParams.get('cities');
    if (raw === null) return false;
    url.searchParams.delete('cities');
    try { history.replaceState(history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
    const ids = raw.split(',').map(s => s.trim()).filter(s => /^(\d+|custom:[A-Za-z0-9_-]+)$/.test(s));
    if (!ids.length) return false;
    const n = Math.min(Math.max(ids.length, SET.min), SET.max);
    if (SET.variants?.[n]) SET.count = n;
    const inputs = allInputs();
    ids.slice(0, SET.count).forEach((id, i) => {
      if (inputs[i] && cfGetVariantById(id)) inputs[i].value = id;
    });
    return true;
  }

  function restore() {
    if (fromLink()) return;
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(SAVE_KEY)); } catch (_) { return; }
    if (!saved || saved.v !== 1 || !Array.isArray(saved.cities)) return;
    if (!(Date.now() - Number(saved.at) < SAVE_MS)) { forget(); return; }
    kept = saved;

    let sized = false;
    try { sized = new URL(window.location.href).searchParams.has('variant'); } catch (_) {}
    const n = Math.round(Number(saved.count));
    if (!sized && n >= SET.min && n <= SET.max && SET.variants?.[n]) SET.count = n;

    const inputs = allInputs();
    saved.cities.slice(0, SET.count).forEach((id, i) => {
      if (inputs[i] && id && cfGetVariantById(id)) inputs[i].value = String(id);
    });
  }

  function restoreExtras() {
    const saved = kept;
    kept = null;
    try {
      if (!saved) return;
      const setSelect = (id, value) => {
        const sel = document.getElementById(id);
        if (!sel || typeof value !== 'string') return;
        if (Array.from(sel.options).some(o => o.value === value)) sel.value = value;
      };
      if (Array.isArray(saved.auto)) {
        setSelect('auto-headline', saved.auto[0]);
        setSelect('auto-subheadline', saved.auto[1]);
      }
      if (Array.isArray(saved.words)) {
        saved.words.slice(0, SET.max).forEach((pair, i) => {
          if (!Array.isArray(pair)) return;
          ['plaque-note-', 'plaque-subnote-'].forEach((prefix, k) => {
            const input = document.getElementById(`${prefix}${i + 1}`);
            if (!input || typeof pair[k] !== 'string') return;
            input.value = input.maxLength > 0 ? pair[k].slice(0, input.maxLength) : pair[k];
          });
        });
      }

      const state = window.CF.STATE;
      state.quiet = true;
      try {
        if (COVERS.includes(saved.cover) && saved.cover !== 'none' && typeof setDisplayCover === 'function') {
          setDisplayCover(saved.cover);
        }
        if (PLAQUES.includes(saved.plaque) && saved.plaque !== 'none' && typeof setPlaque === 'function') {
          state.plaqueMaterial = saved.plaque;
          setPlaque(saved.plaque);
        }
      } finally {
        state.quiet = false;
      }

      for (let i = 1; i <= SET.count; i++) window.CFPlaque?.updatePreview?.(i);
      window.CFPlaque?.syncToGallery?.();
    } finally {
      ready = true;
      /* The add-ons' rows and windows follow what was put back (assets/cf-cover-window.js, cf-plaque-designer.js). */
      document.dispatchEvent(new Event('cf:addon-change'));
    }
  }

  function init() {
    if (!allInputs().every(Boolean)) return;
    /*
      whenDefined rather than a direct call: cf-city-picker.js is a separate
      file, so the elements may not have upgraded yet and `configure` would not
      exist on them. Same reason the bundle configurator waits.
    */
    if (window.customElements) {
      customElements.whenDefined('bcv2-multi-select').then(configurePickers);
    }
    /*
      A design made in the other tab (cf-city-data.js): into the lookup every slot resolves through, then into the
      lists, and into the place that sent the visitor there (cf-city-picker.js, awaitDesign).
    */
    document.addEventListener('cf:designs-change', (e) => {
      const byId = window.CF_VARIANT_LOOKUP?.byId;
      if (byId) (e.detail?.designs || []).forEach(v => { byId[String(v.id)] = { ...v, size: 'cube' }; });
      pickers().forEach(p => p.refresh?.());
    });

    el('[data-set-add]')?.addEventListener('click', (e) => {
      if (SET.count >= SET.max) toggleFullNote();
      else addSlot(e);
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest?.('[data-set-full-note], [data-set-add]')) return;
      closeFullNote();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeFullNote(); });
    document.querySelectorAll('[data-set-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeSlot(Number(btn.dataset.setRemove)));
    });


    restore();
    publish();
    document.addEventListener('input', (e) => { if (e.target.matches?.(PLAQUE_FIELDS)) saveSoon(); });
    document.addEventListener('change', (e) => { if (e.target.matches?.(PLAQUE_FIELDS)) saveSoon(); });
    lastSelection = selection();
    paintSize();
    paintShipping();
    paintCells();
  }

  return { init, onChange, configurePickers, addSlot, removeSlot, save, forget, restoreExtras };
})();

(() => {
  document.addEventListener('DOMContentLoaded', init);
})();
